import React from 'react';

const Writing = () => {
  return (
		<div class="main">
		<h1>Writing</h1>
			<p>There's a couple of pieces of mine on <a href="https://independent.academia.edu/KevNickells" target="_blank" rel="noopener noreferrer">academia.edu</a> on the subjects of Free Improvisation and it's relationship to formal music, and an article on working class politics, socialism, and Happy Hardcore. I also do music journalism for freq.org.uk, my writings in particular are <a href="http://freq.org.uk/tag/kev-nickells/" target="_blank" rel="noopener noreferrer">here</a>.</p>

      <p>I have a book about Taylor Swift coming out with White Owl books May 2024. If you've stumbled across this website from that, well done. Tell your friends I need a record label and my music is astonishing thx </p>

      <p>It's my intention to include a blog on this page soon but I haven't done it so far - let's see how 2024 goes. </p>
		</div>

    )
}

export { Writing }


